import { render } from "./ShareGuys.vue?vue&type=template&id=0abb45b4&scoped=true"
import script from "./ShareGuys.vue?vue&type=script&lang=js"
export * from "./ShareGuys.vue?vue&type=script&lang=js"

import "./ShareGuys.vue?vue&type=style&index=0&id=0abb45b4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0abb45b4"]])

export default __exports__